/**
 * Where a user is sent when the product cannot help them in place.
 *
 * Shared because a support address that differs between two dead-end screens
 * is worse than no address at all. `src/libs/PublicQuote/*` still carries its
 * own copies from before this existed; fold them in when that area is touched.
 */
export const SUPPORT_EMAIL = "support@sameday.ai";
